import { type FC } from "react";

import { Calendar as BaseCalendar, type CalendarProps as BaseCalendarProps } from "./Calendar";
import { type RangeCalendarProps as BaseRangeCalendarProps, RangeCalendar } from "./RangeCalendar";

export type CalendarProps = BaseCalendarProps & { ranged?: false };
export type RangeCalendarProps = BaseRangeCalendarProps & { ranged: true };

export const Calendar: FC<CalendarProps | RangeCalendarProps> = (props) => {
	if (props.ranged === true) {
		return <RangeCalendar {...props} />;
	}

	return <BaseCalendar {...props} />;
};
